import { Box, Button, Rating, Table, TableBody, TableCell, TableContainer, TableRow, ToggleButton, ToggleButtonGroup, Typography, useTheme } from '@mui/material'
import { useState, useEffect, useCallback, useMemo } from 'react'
import { toast } from 'react-toastify'
import { observer } from 'mobx-react'
import dayjs from 'dayjs'

import TryAgainMessageBlock from '../../components/common/TryAgainMessageBlock'
import { useOrganizationStore } from '../../../src/store/organization.store'
import DataLoadingSpinner from '../../components/common/DataLoadingSpinner'
import SelectInstitute from '../../components/admin/SelectInstitute'
import BlockMessage from '../../components/common/BlockMessage'
import { useNavigate, useSearchParams } from 'react-router-dom'
import CustomSwitch from '../../components/common/CustomSwitch'
import TableHeader from '../../components/common/TableHeader'
import { useRoomStore } from '../../../src/store/room.store'
import noClassesImg from '../../assets/noclasses.svg'
import { useUserStore } from '../../store/user.store'
import { Icons } from '../../utils/utilities'
import api from '../../service/api'
import CustomChip from '../../components/common/CustomChip'
import { useSettingsStore } from '../../store/settings.store'
import CustomTable from '../../components/common/custom-table/CustomTable'

const user = 'admin'

const sortRooms = ( rooms ) => {
    try {
        const sortedRooms = rooms.sort( ( a, b ) => {
            const normalizeTime = ( room ) => {
                return new Date( room.starts_at ).getTime()
            }
            return normalizeTime( a ) - normalizeTime( b )
        } )
        return sortedRooms
    } catch ( err ) {
        console.log( err )
        return rooms
    }
}

const checkTime = ( sTime, eTime ) => {
    // if ( UserStore.getUser.user_id === 'AI002432' ) {
    //     return true

    // } else {
    var currentDate = new Date()
    var currentTime = currentDate.toString().split( " " )[4]
    var sTimeSplit = sTime.split( ":" )
    var eTimeSplit = eTime.split( ":" )
    var cTimeSplit = currentTime.split( ":" )
    var sTimeHr = parseInt( sTimeSplit[0] ), sTimeMin = parseInt( sTimeSplit[1] )
    var eTimeHr = parseInt( eTimeSplit[0] ), eTimeMin = parseInt( eTimeSplit[1] )
    var cTimeHr = parseInt( cTimeSplit[0] ), cTimeMin = parseInt( cTimeSplit[1] )
    var startMin = 0, endMin = 0, currentMin = 0
    if ( sTimeHr === 0 ) {
        startMin = sTimeMin
    } else if ( sTimeHr > 0 ) {
        startMin = ( ( 60 * sTimeHr ) + sTimeMin )
    }
    if ( eTimeHr === 0 ) {
        endMin = eTimeMin
    } else if ( eTimeHr > 0 ) {
        endMin = ( ( 60 * eTimeHr ) + eTimeMin )
    }
    if ( cTimeHr === 0 ) {
        currentMin = cTimeMin
    } else if ( cTimeHr > 0 ) {
        currentMin = ( ( 60 * cTimeHr ) + cTimeMin )
    }

    if ( currentMin >= ( startMin - 5 ) && currentMin <= endMin ) {
        return true
    }
    else {
        return false
    }
    // }
}

const LiveClass = observer( () => {

    const OrganizationStore = useOrganizationStore()
    const UserStore = useUserStore()

    const { layout, border, palette } = useTheme()

    const [upcomingOnlineSessions, setUpcomingOnlineSessions] = useState( [] )
    const [hideEnded, setHideEnded] = useState( false )
    const [isLoading, setIsLoading] = useState( false )
    const [hasAccess, setHasAccess] = useState( true )
    const [dateFilter, setDateFilter] = useState( '' )
    const [error, setError] = useState( null )

    const [searchParams, setSearchParams] = useSearchParams( { instituteCode: "all" } )
    const instituteCode = searchParams.get( "instituteCode" ) || "all"

    const columns = useMemo( () => {
        return [
            {
                name: "Details",
                field: "details",
                width: "190px",
                renderCell: ( row ) => (
                    <Box sx={{ padding: "10px 0" }}>
                        {row.meeting_type.includes( 'class' ) ? (
                            <Box>
                                Course : {row["course_short_name"] || row["course_code"] || "Not Available"} <br />
                                <small>
                                    Semester {row["current_sem"]} -
                                    {row["section_short_name"] !== "NA" && ` Section ${row["section_short_name"]}`}
                                    {row["batch_name"] && ` Batch ${row["batch_name"]}`}
                                </small>
                            </Box>
                        ) : (
                            <Box>
                                Title : {row["title"]} <br />
                                <small>Access: {row["access_type"]}</small>
                            </Box>
                        )}
                    </Box>
                )
            },
            {
                name: "Institute - Branch",
                field: "institute_branch",
                width: "200px",
                renderCell: ( row ) => (
                    <Box sx={{ fontSize: "12px" }}>
                        {row["institute_name_short"]} - {row["branch_name"]}
                    </Box>
                )
            },
            {
                name: "Type",
                field: "meeting_type",
                width: "150px",
                renderCell: ( row ) => (
                    <Box sx={{ fontSize: "12px" }}>
                        <Typography
                            border={border[1]}
                            variant="subtitle2"
                            bgcolor={palette.contentBg}
                            width="fit-content"
                            borderRadius="5px"
                            padding="5px"
                            display="flex"
                            alignItems="center"
                            fontSize="inherit"
                            gap="5px"
                        >
                            {( row["meeting_type"] === 'class' || row["meeting_type"] === 'class/hybrid' ) && Icons.default.School}
                            {row["meeting_type"] === 'hybrid-class' && Icons.default.HybridClasses}
                            {row["meeting_type"] === 'discussion' && Icons.default.Group}
                            {row["meeting_type"] === 'webinar' && Icons.default.MeetingRooms}
                            {row["meeting_type"]}
                        </Typography>
                    </Box>
                )
            },
            {
                name: "Presenter",
                field: "presenter_name",
                renderCell: ( row ) => (
                    <Box sx={{ fontSize: "12px" }}>
                        {row["presenter_name"] ? row["presenter_name"] : "Not Available"}
                    </Box>
                )
            },
            {
                name: "Videos",
                field: "videos_count",
                align: "center",
                renderCell: ( row ) => (
                    <Box sx={{ fontSize: "12px", display: "flex", justifyContent: "center" }}>
                        {row["videos_count"] ? row["videos_count"] : row["meeting_type"] === 'hybrid-class' ? "Not Uploaded" : "NA"}
                    </Box>
                )
            },
            {
                name: "Subject",
                field: "subject_name_short",
                renderCell: ( row ) => (
                    <Box sx={{ fontSize: "12px" }}>
                        {row["subject_name_short"] || "NA"}
                    </Box>
                )
            },
            {
                name: "Date & Time",
                field: "date_time",
                width: "170px",
                renderCell: ( row ) => (
                    <Box sx={{ fontSize: "12px" }}>
                        <Typography fontSize="inherit" display="flex" gap="5px" alignItems="center">
                            {Icons.default.Calendar} {row.selected_date}
                        </Typography>
                        <Typography fontSize="inherit" display="flex" gap="5px" alignItems="center">
                            {Icons.default.Clock} {row["intervals"]}
                        </Typography>
                    </Box>
                )
            },
            {
                name: "Taken",
                field: "doesSessionExists",
                width: "150px",
                renderCell: ( row ) => (
                    <Box sx={{ fontSize: "12px" }}>
                        {row.meeting_type.includes( 'class' ) ? (
                            <CustomChip
                                color={row.doesSessionExists ? "success" : "error"}
                                variant="filled"
                                value={row.doesSessionExists ? "Yes" : "No"}
                            />
                        ) : (
                            <CustomChip variant="filled" value="Not Applicable" />
                        )}
                    </Box>
                )
            },
            {
                name: "Status",
                field: "status",
                width: "120px",
                renderCell: ( row ) => {
                    const computedStatus =
                        row.ends_at && dayjs( row.ends_at ).isBefore( dayjs() )
                            ? "ended"
                            : row.status

                    return (
                        <Box sx={{ fontSize: "12px", textTransform: "capitalize" }}>
                            <Typography
                                fontSize="inherit"
                                padding="3px 5px"
                                borderRadius="5px"
                                width="fit-content"
                                border={
                                    computedStatus === "not-started"
                                        ? border[1]
                                        : computedStatus === "on-going"
                                            ? `1px solid ${palette.success.main}`
                                            : `1px solid ${palette.error.main}`
                                }
                                bgcolor={
                                    computedStatus === "not-started"
                                        ? palette.contentBg
                                        : computedStatus === "on-going"
                                            ? palette.success.light + "33"
                                            : palette.error.light + "33"
                                }
                            >
                                {computedStatus?.replace( /-/g, " " )}
                            </Typography>
                        </Box>
                    )
                }
            },
            {
                name: "Ratings",
                field: "ratings",
                width: "120px",
                renderCell: ( row ) => {
                    const isFinishedOrOngoing = row["status"] === "ended" || row["status"] === "on-going"
                    return (
                        <Box sx={{ fontSize: "12px", textTransform: "capitalize", display: "flex", gap: "5px", alignItems: "center" }}>
                            <Rating
                                size="small"
                                readOnly
                                value={isFinishedOrOngoing ? row?.feedback?.ratings || 0 : 0}
                            />
                            <Typography variant="subtitle2" fontSize="10px">
                                ({isFinishedOrOngoing ? row?.feedback?.count || 0 : 0})
                            </Typography>
                        </Box>
                    )
                }
            },
            {
                name: "Action",
                field: "action",
                align: "right",
                stickTo: "right",
                width: "230px",
                renderCell: ( row ) => {
                    const computedStatus =
                        row.ends_at && dayjs( row.ends_at ).isBefore( dayjs() )
                            ? "ended"
                            : row.status

                    return (
                        <Box sx={{ display: "flex", justifyContent: "flex-end", alignItems: "center", gap: "10px" }}>
                            {row.doesSessionExists && (
                                <Button
                                    sx={{ flexShrink: 0 }}
                                    size="small"
                                    variant="contained"
                                    color="secondary"
                                    onClick={() => viewSessionDetails( row )}
                                    disableElevation
                                    className="mr-2"
                                >
                                    View Details
                                </Button>
                            )}
                            {row.meeting_type !== "hybrid-class" && (
                                <Button
                                    sx={{ flexShrink: 0 }}
                                    size="small"
                                    variant="contained"
                                    color="primary"
                                    onClick={() => joinSession( row )}
                                    disabled={!row.doesSessionExists || computedStatus === 'ended'}
                                    disableElevation
                                >
                                    Join {row.meeting_type}
                                </Button>
                            )}
                        </Box>
                    )
                }
            }
        ]
    }, [border, palette] )

    const joinSession = async ( sessionDetails ) => {
        try {
            if ( sessionDetails.meeting_type !== 'class' ) {
                return window.open( `/${["webinar", "class"].includes( sessionDetails.meeting_type ) ? sessionDetails.meeting_type : "meeting"}/${sessionDetails.id}` )
            }
            const { data: { data: meeting } } = await api.onlineMeetings.fetchClassMeeting( sessionDetails.time_table_id )
            window.open( `/class/${meeting.id}` )

        } catch ( err ) {
            console.log( err )
        }
    }

    const viewSessionDetails = ( sessionDetails ) => {
        try {
            const type = ["webinar", "discussion"].includes( sessionDetails.meeting_type ) ? "meetings" : sessionDetails.meeting_type === "class" ? "online-classes" : sessionDetails.meeting_type === "hybrid-class" ? "hybrid-classes" : "meetings"
            window.open( `/admin/${type}/${sessionDetails.id}` )
        } catch ( err ) {
            console.log( err )
        }
    }


    const endSession = async ( data ) => {
        try {
            try {
                await api.onlineMeetings.endMeeting( data.id )
            } catch ( err ) {
                toast( err?.response?.data?.message || "Failed to end the session, please try again." )
            }
        } catch ( err ) {

        }
    }

    const filterFunc = ( item ) => {
        if ( !hideEnded )
            return true

        return !( item.status === "ended" || ( item.ends_at && dayjs( item.ends_at ).isBefore( dayjs() ) ) )
    }

    const dateFilters = useMemo( () => {
        const today = dayjs()
        const tomorrow = today.add( 1, 'day' )
        const filters = []
        filters.push( { label: "Week", value: "" } )
        filters.push( { label: "Tod", value: today.format( "YYYY-MM-DD" ) } )
        filters.push( { label: "Tom", value: tomorrow.format( "YYYY-MM-DD" ) } )
        for ( let i = 2; i <= 7; i++ ) {
            const val = today.add( i, 'day' )
            filters.push( {
                label: val.format( "MMM, DD" ),
                value: val.format( "YYYY-MM-DD" )
            } )
        }

        return filters
    }, [] )


    const getOrgDetails = useCallback( async () => {
        if ( UserStore.getUser.user_auditor || ["admin", "subadmin"].includes( UserStore.getUser.user_role?.toLowerCase() ) ) {
            if ( UserStore.getUser.user_role.toLowerCase() === 'subadmin' ) {
                if ( UserStore.getUser.user_permissions.live_class_audit ) {
                    if ( OrganizationStore.getOrganization?.length === 0 )
                        await OrganizationStore.fetchOrganization()
                } else {
                    setHasAccess( false )
                }
            } else
                if ( OrganizationStore.getOrganization?.length === 0 )
                    await OrganizationStore.fetchOrganization()
        } else {
            setHasAccess( false )
        }
    }, [OrganizationStore, UserStore] )

    const getAuditData = useCallback( async ( code ) => {
        try {
            setIsLoading( true )

            const requests = []

            requests.push( api.auditSession() )
            requests.push( api.getSettings( { filter: "all" } ) )

            const [{ data: { data: { upcomingClasses, upcomingMeetingsAndClasses } } }, { data: { data: allSettings } }] = await Promise.all( requests )

            const aliveOnlineClassSessions = upcomingMeetingsAndClasses.filter( session => ['class', 'hybrid-class'].includes( session.meeting_type ) )


            upcomingClasses.forEach( oc => {
                const classSessionDetails = aliveOnlineClassSessions.find( aoc => aoc.time_table_id === oc.time_table_id )
                if ( classSessionDetails ) {
                    oc.doesSessionExists = true
                    for ( const key in classSessionDetails ) {
                        if ( !Object.hasOwn( classSessionDetails, key ) ) continue
                        oc[key] = classSessionDetails[key]
                    }
                } else {
                    oc.doesSessionExists = false
                    oc.status = "not-started"  // 'on-going','ended','not-started'

                    const hybridClassEnabledCourses = allSettings[oc.institute_name_short]?.find( setting => setting.setting_key === "hybrid_class_subjects_codes" ) || []

                    oc.meeting_type = hybridClassEnabledCourses?.value?.includes( oc.course_code ) ? "class/hybrid" : "class"
                    oc.starts_at = dayjs( `${oc.selected_date}T${oc.sTime}` )
                    oc.ends_at = dayjs( `${oc.selected_date}T${oc.eTime}` )
                }
                return oc
            } )

            const meetingsAndWebinars = upcomingMeetingsAndClasses.filter( session => !['class', 'hybrid-class'].includes( session.meeting_type ) )
            meetingsAndWebinars.forEach( ms => {
                let intervals = ''
                intervals += dayjs( ms.starts_at ).format( "hh:mm A" )
                intervals += " - "
                intervals += dayjs( ms.ends_at ).format( "hh:mm A" )
                ms.intervals = intervals
                ms.selected_date = dayjs( ms.starts_at ).format( "YYYY-MM-DD" )

                ms.doesSessionExists = ms.status === 'on-going'
            } )

            const allSessions = sortRooms( [...upcomingClasses, ...meetingsAndWebinars] )

            setUpcomingOnlineSessions( allSessions )
            setError( null )
            setIsLoading( false )
        } catch ( err ) {
            console.log( err )
            setError( { code: err?.response?.status, message: err?.response?.data?.message || "Failed to fetch upcoming classes and meetings" } )
        } finally {
            setIsLoading( false )
        }
    }, [] )

    useEffect( () => {
        getOrgDetails()
        getAuditData()
    }, [getOrgDetails, getAuditData] )

    const filteredSessions = upcomingOnlineSessions.filter( item => ( instituteCode === "all" || item.institute_name_short.includes( instituteCode ) ) && item.selected_date.includes( dateFilter ) )

    return (
        hasAccess ? <Box flexGrow={1} padding={layout.pagePadding} overflow="auto" display="flex" flexDirection="column">
            <Box flexGrow={1} display="flex" flexDirection="column" gap={layout.sectionsGap} >
                {( UserStore.getUser.user_auditor || ["admin", "subadmin"].includes( UserStore.getUser.user_role?.toLowerCase() ) ) && <Box display="flex" flexDirection={{ xs: "column", sm: "row" }} justifyContent="space-between" gap="20px" alignItems={{ sm: "center", xs: "stretch" }}>
                    <Box flexGrow="1">
                        <Typography variant="h1" fontWeight="600" component="h1" fontSize="16px">Upcoming online classes and meetings.</Typography>
                        <Typography variant="subtitle2" fontSize="12px" color='textSecondary' >Check upcoming and currently running online classes.</Typography>
                    </Box>
                </Box>}
                <Box display="flex" gap={layout.cardsGap} flexDirection="column" >

                    <Box display="flex" flexWrap="wrap" gap={layout.cardsGap}>

                        <Box onClick={() => setHideEnded( prev => !prev )} alignItems="center" display="flex" gap={layout.cardsGap} border={border[1]} bgcolor={palette.contentBg} padding="2px 10px" borderRadius={layout.borderRadius} sx={{ cursor: "pointer" }} >
                            <Typography variant='subtitle2' fontSize="12px">Hide Ended sessions</Typography>
                            <CustomSwitch checked={hideEnded} size="small" />
                        </Box>

                        <SelectInstitute showDefault={false} showAllOption containerStyles={{ flexGrow: { md: "initial", xs: "1" } }} value={instituteCode} onSelect={( instituteCode ) => {
                            setSearchParams( prev => {
                                const newValue = new URLSearchParams( prev )
                                newValue.set( 'instituteCode', instituteCode )
                                return newValue
                            }, { replace: true } )
                        }} />

                        <ToggleButtonGroup
                            size='small'
                            value={dateFilter}
                            exclusive
                            onChange={( event, val ) => {
                                if ( val || val === "" )
                                    setDateFilter( val )
                            }}
                            aria-label="date filter"
                        >
                            {dateFilters.map( filter => (
                                <ToggleButton sx={{ textTransform: "capitalize" }} value={filter.value} key={filter.value} >
                                    {filter.label}
                                </ToggleButton>
                            ) )}
                        </ToggleButtonGroup>
                    </Box>

                    {!isLoading && !error && filteredSessions.filter( filterFunc ).length > 0 && <CustomTable data={filteredSessions.filter( filterFunc )} columns={columns} />}
                </Box>
                {!isLoading && !error && filteredSessions.filter( filterFunc ).length === 0 && <Box sx={{ textAlign: "center", fontSize: "24px", fontWeight: "bold", variant: 'h5', padding: "20px", borderRadius: "0 0 5px 5px", display: "flex", flexDirection: "column", alignItems: "center", gap: "10px" }}>
                    <img src={noClassesImg} width="200px" alt="No live classes going on!" />
                    <Typography variant='subtitle2' color="textSecondary" marginTop="10px">
                        {( dateFilter === "" && instituteCode === "all" ) && "No online sessions scheduled in the next 7 days."}
                        {( dateFilter === "" && instituteCode !== "all" ) && `No online sessions scheduled in the next 7 days for ${instituteCode}.`}
                        {( dateFilter && instituteCode === "all" ) && `No online sessions scheduled on ${dateFilter}.`}
                        {( dateFilter && instituteCode !== "all" ) && `No online sessions scheduled for ${instituteCode} on ${dateFilter}.`}
                    </Typography>
                </Box>}
                {isLoading && !error && <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%", textAlign: "center" }}>
                    <DataLoadingSpinner waitingMessage="Loading rooms..." />
                </Box>}
                {error && <TryAgainMessageBlock err={error.message} code={error.code} getData={getAuditData} loading={isLoading} />}
            </Box>
        </Box> : <Box padding="20px">
            <BlockMessage message={<span>You doesn't have permission to access this page! please contact <i>Alive co-ordinators</i> for further information.</span>} type="error" />
        </Box>
    )
} )

export default LiveClass
